export const COMPANY_INFO = {
  name: "CLOUD COMPUTING TECHNOLOGY SP Z O O",
  address: "Ul. Al. Aleje Jerozolimskie 109/70, 02-011 Warsaw, Poland",
  email: "support@music-producer.ai",
};
